import { default as _91_46_46_46cms_93JJ4f1v3jbFMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93cqMLNYPOusMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/3d-projects/[...slug].vue?macro=true";
import { default as indexuErRINTkZxMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93vGciHrFmlOMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/akcii/[...slug].vue?macro=true";
import { default as index0t0wfKjbZTMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_93ATxCLxdJLeMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/articles/[...slug].vue?macro=true";
import { default as indexOulY17cEeMMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/articles/index.vue?macro=true";
import { default as indexUtWFcHTeSHMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/authorization/index.vue?macro=true";
import { default as indexaT42M2LmBkMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93IQBLFWj2LsMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93wogVXklXEOMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/catalog/[...slug].vue?macro=true";
import { default as indexz54wck0KRYMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93UpRreTCzrAMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultxBNiueLXG3Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/catalogsearch/result.vue?macro=true";
import { default as indexEEEeUjR9wPMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93cnhsrEr149Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93NqRskSDTXcMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/fabriki/[...slug].vue?macro=true";
import { default as indexiQW5l0d3aIMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/fabriki/index.vue?macro=true";
import { default as _91_46_46_46slug_93W9YLHtCdgYMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/product/[...slug].vue?macro=true";
import { default as indexcqOYHlnbrzMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/profile/index.vue?macro=true";
import { default as indexdeIsRdgugnMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/profile/orders/index.vue?macro=true";
import { default as indexZxjMk6MS3KMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93dFpJZZ5et4Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/sets/[...slug].vue?macro=true";
import { default as indexwVuvEdCvGgMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93JJ4f1v3jbFMeta?.name ?? "cms",
    path: _91_46_46_46cms_93JJ4f1v3jbFMeta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93JJ4f1v3jbFMeta || {},
    alias: _91_46_46_46cms_93JJ4f1v3jbFMeta?.alias || [],
    redirect: _91_46_46_46cms_93JJ4f1v3jbFMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93cqMLNYPOusMeta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93cqMLNYPOusMeta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93cqMLNYPOusMeta || {},
    alias: _91_46_46_46slug_93cqMLNYPOusMeta?.alias || [],
    redirect: _91_46_46_46slug_93cqMLNYPOusMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexuErRINTkZxMeta?.name ?? "3d-projects",
    path: indexuErRINTkZxMeta?.path ?? "/3d-projects",
    meta: indexuErRINTkZxMeta || {},
    alias: indexuErRINTkZxMeta?.alias || [],
    redirect: indexuErRINTkZxMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93vGciHrFmlOMeta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93vGciHrFmlOMeta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93vGciHrFmlOMeta || {},
    alias: _91_46_46_46slug_93vGciHrFmlOMeta?.alias || [],
    redirect: _91_46_46_46slug_93vGciHrFmlOMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index0t0wfKjbZTMeta?.name ?? "akcii",
    path: index0t0wfKjbZTMeta?.path ?? "/akcii",
    meta: index0t0wfKjbZTMeta || {},
    alias: index0t0wfKjbZTMeta?.alias || [],
    redirect: index0t0wfKjbZTMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93ATxCLxdJLeMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_93ATxCLxdJLeMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93ATxCLxdJLeMeta || {},
    alias: _91_46_46_46slug_93ATxCLxdJLeMeta?.alias || [],
    redirect: _91_46_46_46slug_93ATxCLxdJLeMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexOulY17cEeMMeta?.name ?? "articles",
    path: indexOulY17cEeMMeta?.path ?? "/articles",
    meta: indexOulY17cEeMMeta || {},
    alias: indexOulY17cEeMMeta?.alias || [],
    redirect: indexOulY17cEeMMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: indexUtWFcHTeSHMeta?.name ?? "authorization",
    path: indexUtWFcHTeSHMeta?.path ?? "/authorization",
    meta: indexUtWFcHTeSHMeta || {},
    alias: indexUtWFcHTeSHMeta?.alias || [],
    redirect: indexUtWFcHTeSHMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexaT42M2LmBkMeta?.name ?? "cart",
    path: indexaT42M2LmBkMeta?.path ?? "/cart",
    meta: indexaT42M2LmBkMeta || {},
    alias: indexaT42M2LmBkMeta?.alias || [],
    redirect: indexaT42M2LmBkMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93IQBLFWj2LsMeta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93IQBLFWj2LsMeta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93IQBLFWj2LsMeta || {},
    alias: _91_46_46_46id_93IQBLFWj2LsMeta?.alias || [],
    redirect: _91_46_46_46id_93IQBLFWj2LsMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93wogVXklXEOMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93wogVXklXEOMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93wogVXklXEOMeta || {},
    alias: _91_46_46_46slug_93wogVXklXEOMeta?.alias || [],
    redirect: _91_46_46_46slug_93wogVXklXEOMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexz54wck0KRYMeta?.name ?? "catalog",
    path: indexz54wck0KRYMeta?.path ?? "/catalog",
    meta: indexz54wck0KRYMeta || {},
    alias: indexz54wck0KRYMeta?.alias || [],
    redirect: indexz54wck0KRYMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93UpRreTCzrAMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93UpRreTCzrAMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93UpRreTCzrAMeta || {},
    alias: _91_46_46_46slug_93UpRreTCzrAMeta?.alias || [],
    redirect: _91_46_46_46slug_93UpRreTCzrAMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultxBNiueLXG3Meta?.name ?? "catalogsearch-result",
    path: resultxBNiueLXG3Meta?.path ?? "/catalogsearch/result",
    meta: resultxBNiueLXG3Meta || {},
    alias: resultxBNiueLXG3Meta?.alias || [],
    redirect: resultxBNiueLXG3Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: indexEEEeUjR9wPMeta?.name ?? "clear-page-slider",
    path: indexEEEeUjR9wPMeta?.path ?? "/clear-page-slider",
    meta: indexEEEeUjR9wPMeta || {},
    alias: indexEEEeUjR9wPMeta?.alias || [],
    redirect: indexEEEeUjR9wPMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93cnhsrEr149Meta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93cnhsrEr149Meta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93cnhsrEr149Meta || {},
    alias: _91_46_46_46slug_93cnhsrEr149Meta?.alias || [],
    redirect: _91_46_46_46slug_93cnhsrEr149Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93NqRskSDTXcMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93NqRskSDTXcMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93NqRskSDTXcMeta || {},
    alias: _91_46_46_46slug_93NqRskSDTXcMeta?.alias || [],
    redirect: _91_46_46_46slug_93NqRskSDTXcMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexiQW5l0d3aIMeta?.name ?? "fabriki",
    path: indexiQW5l0d3aIMeta?.path ?? "/fabriki",
    meta: indexiQW5l0d3aIMeta || {},
    alias: indexiQW5l0d3aIMeta?.alias || [],
    redirect: indexiQW5l0d3aIMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93W9YLHtCdgYMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93W9YLHtCdgYMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93W9YLHtCdgYMeta || {},
    alias: _91_46_46_46slug_93W9YLHtCdgYMeta?.alias || [],
    redirect: _91_46_46_46slug_93W9YLHtCdgYMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexcqOYHlnbrzMeta?.name ?? "profile",
    path: indexcqOYHlnbrzMeta?.path ?? "/profile",
    meta: indexcqOYHlnbrzMeta || {},
    alias: indexcqOYHlnbrzMeta?.alias || [],
    redirect: indexcqOYHlnbrzMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexdeIsRdgugnMeta?.name ?? "profile-orders",
    path: indexdeIsRdgugnMeta?.path ?? "/profile/orders",
    meta: indexdeIsRdgugnMeta || {},
    alias: indexdeIsRdgugnMeta?.alias || [],
    redirect: indexdeIsRdgugnMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexZxjMk6MS3KMeta?.name ?? "recently",
    path: indexZxjMk6MS3KMeta?.path ?? "/recently",
    meta: indexZxjMk6MS3KMeta || {},
    alias: indexZxjMk6MS3KMeta?.alias || [],
    redirect: indexZxjMk6MS3KMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93dFpJZZ5et4Meta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93dFpJZZ5et4Meta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93dFpJZZ5et4Meta || {},
    alias: _91_46_46_46slug_93dFpJZZ5et4Meta?.alias || [],
    redirect: _91_46_46_46slug_93dFpJZZ5et4Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexwVuvEdCvGgMeta?.name ?? "wishlist",
    path: indexwVuvEdCvGgMeta?.path ?? "/wishlist",
    meta: indexwVuvEdCvGgMeta || {},
    alias: indexwVuvEdCvGgMeta?.alias || [],
    redirect: indexwVuvEdCvGgMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260504105859/pages/wishlist/index.vue").then(m => m.default || m)
  }
]